// import { useEffect, useState } from 'react'
// import ym from 'react-yandex-metrika'

// import { getCookie, setCookie } from '../../components/cookie/cookie'
import NewMain from '../../components/NewMain/NewMain'
// import NewMain2 from '../../components/NewMain2/NewMain2'
import { Layout } from '../../components/UI/Layout/Layout'
// import { scrollPageStop } from '../../helpers/scrollUtils'

export const NewMainPage = () => {
  // const [componentToShow, setComponentToShow] = useState('')

  // const initPageAnalytics = (selectedComponent: string) => {
  //   const num = selectedComponent === 'new' ? 2 : 1

  //   ym('userParams', {
  //     AB_main_user: num,
  //   })
  //   ym('reachGoal', `AB_main_${num}`, {
  //     AB_main_session: num,
  //   })
  // }

  // useEffect(() => {
  //   scrollPageStop(false)

  //   let selectedComponent = getCookie('BITRIX_SM_ab_design_code')
  //   selectedComponent = selectedComponent ? selectedComponent : ''
  //   setComponentToShow(selectedComponent)
  //   initPageAnalytics(selectedComponent)
  // }, [])

  return (
    <Layout>
      <NewMain />
      {/* <div className='main__wrapper js-main'>
      {componentToShow === 'old' ? (
      ) : componentToShow === 'new' ? (
        <NewMain2 />
      ) : null}
      </div>*/}
    </Layout>
  )
}
